import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { HelmetProvider } from '@carouselgg/nexus/seo'
import '@carouselgg/nexus/tokens'
import '@carouselgg/nexus/reset'
import '@carouselgg/nexus/selection'
import './global.css'
import { ThemeProvider } from '@carouselgg/nexus/theme'
import { Toaster } from '@carouselgg/nexus/toast'
import { ErrorPage } from '@carouselgg/nexus/status-page'
import { initAuthStore } from '@carouselgg/auth/store'
import { App } from './App.tsx'
import { initUmami } from './utils/umami'
import { initSentry } from './utils/sentry'
import { initPreloadErrorHandler } from './utils/preloadError'

initSentry('app')
initPreloadErrorHandler()
initUmami()
initAuthStore()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => (
        <ErrorPage onRetry={resetError} onGoHome={() => { window.location.href = '/' }} />
      )}
    >
      <HelmetProvider>
        <ThemeProvider>
          <App />
          <Toaster />
        </ThemeProvider>
      </HelmetProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
